<template>
  <el-dialog
    width="650px"
    :title="'导入数据集字段列表（使用模板）'"
    :close-on-click-modal="false"
    @close="closeHandle"
    :visible.sync="visible">
    <el-upload
      drag
      :action="uploadUrl"
      accept=".xls,.xlsx"
      :on-success="successHandle"
      :multiple="false"
      :name="fileName"
      :show-file-list="false"
      style="text-align: center;">
      <i class="el-icon-upload"></i>
      <div class="el-upload__text">将文件拖到此处，或<em>点击上传</em></div>
      <div class="el-upload__tip" slot="tip">只支持xls、xlsx格式的表格</div>
    </el-upload>
  </el-dialog>
</template>

<script>
  export default {
    data() {
      return {
        fileName:'file',
        visible: false,
        uploadUrl:'',
        num: 0,
        successNum: 0,
        fileList: [],
        ruleId:''
      }
    },
    methods: {
      init(ruleId) {
        this.visible = true
        this.ruleId=ruleId
        this.uploadUrl=process.env.VUE_APP_proxybaseurl + `/customform/tablemeta/import/upload?ruleId=${ruleId}`
        this.num=0
        this.fileList=[]
      },
      // 上传成功
      successHandle (response, file, fileList) {
        this.fileList = fileList
        this.successNum++
        if (response && response.code === '1') {
          this.$message('上传成功')
        } else {
          this.$message.error(response.msg)
        }
      },
      closeHandle () {
        this.fileList = []
        this.$emit('refreshDataList')
      },
    }
  }
</script>
